import { connect } from "react-redux";
import TrendHeatmap from "./TrendHeatmap";


const mapStateToProps = (state) => ({
    fetchTrendRaterHeatmapApi: state.BenchmarkFilteringReducer.fetchTrendRaterHeatmapApi

});

const mapDispatchToProps = (dispatch) => ({

});


export default connect(mapStateToProps, mapDispatchToProps)(TrendHeatmap);
